import { IMarginValue, MarginValue } from './margin-value.model';

export interface IPassengerTypeConfig {
  single?: IMarginValue;
  thirdAdult?: IMarginValue;
  fourthAdult?: IMarginValue;
  childOne?: IMarginValue;
  childTwo?: IMarginValue;
  baby?: IMarginValue;
}

export class PassengerTypeConfig implements IPassengerTypeConfig {
  constructor(
    public single?: MarginValue,
    public thirdAdult?: MarginValue,
    public fourthAdult?: MarginValue,
    public childOne?: MarginValue,
    public childTwo?: MarginValue,
    public baby?: MarginValue
  ) {}
}

/** Ordered list of passenger types with their display label, used to render the surcharge editor rows. */
export const PASSENGER_TYPE_CONFIG_KEYS: {
  key: keyof IPassengerTypeConfig;
  label: string;
}[] = [
  { key: 'single', label: 'Single' },
  { key: 'thirdAdult', label: '3e adulte' },
  { key: 'fourthAdult', label: '4e adulte' },
  { key: 'childOne', label: 'Enfant 1' },
  { key: 'childTwo', label: 'Enfant 2' },
  { key: 'baby', label: 'Bébé' },
];
